'use client';

import { useState, useEffect } from 'react';


export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#services', label: 'Services' },
    { href: '#why-us', label: 'Why Us' },
    { href: '#service-area', label: 'Service Area' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-navy-dark/95 backdrop-blur-md border-b border-gold-faint py-3' :'bg-transparent py-5'
      }`}
    >
      <div className="max-w-editorial mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group">
          <div className="w-8 h-8 rounded-full border-2 border-gold flex items-center justify-center">
            <div className="w-5 h-5 rounded-full border border-dashed border-gold/60 flex items-center justify-center">
              <span className="font-fraunces text-[0.35rem] font-700 text-gold leading-none tracking-tight text-center">DFW</span>
            </div>
          </div>
          <div>
            <span className="font-fraunces text-[1.1rem] font-700 text-cream tracking-tight leading-none block">DFW Notary Pro</span>
            <span className="font-dm text-[0.55rem] font-600 uppercase tracking-[0.2em] text-gold/70 leading-none">dfwnotary.pro</span>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="font-dm text-[0.7rem] font-600 uppercase tracking-[0.18em] text-slate hover:text-gold transition-colors duration-200"
            >
              {link?.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+14695550183"
            className="font-dm text-[0.72rem] font-700 uppercase tracking-[0.15em] text-gold border border-gold-faint px-4 py-2 rounded-editorial hover:bg-gold-faint transition-all duration-250"
          >
            Call Now
          </a>
          <a
            href="#contact"
            className="cta-primary text-[0.72rem] py-2 px-5"
          >
            Book Now
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-cream transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-cream transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-cream transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-navy-dark border-t border-gold-faint px-6 py-6 space-y-4">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className="block font-dm text-[0.8rem] font-600 uppercase tracking-[0.18em] text-slate hover:text-gold transition-colors py-2"
            >
              {link?.label}
            </a>
          ))}
          <div className="pt-4 flex flex-col gap-3">
            <a href="tel:+14695550183" className="cta-secondary text-center justify-center">Call Now</a>
            <a href="#contact" onClick={() => setMobileOpen(false)} className="cta-primary text-center justify-center">Book Now</a>
          </div>
        </div>
      )}
    </header>
  );
}